import React, { useState, useEffect } from 'react'
import { getMappedcampagions, downloadMappedcamapgins } from '../../../../actioncreatormarketing'
import Pagination from '@mui/material/Pagination'
import Stack from '@mui/material/Stack'
export default function MappedCamapginsList({ setLoader }) {
    const [campaignUnmapped, setcampaignUnmapped] = useState([])
    const [page, setPage] = useState(1)
    const rowsPerPage = 10;

    useEffect(() => {
        List()
    }, [])

    const List = () => {
        setLoader(true)
        getMappedcampagions(callback => {
            setLoader(false)
            setcampaignUnmapped(callback ?? [])
        })
    }

    const download = () => {
        setLoader(true)
        downloadMappedcamapgins(callback => {
            setLoader(false)
        })
    }

    const handleChange = (event, value) => {
        setPage(value)
    }

    const startIndex = (page - 1) * rowsPerPage
    const paginatedData = campaignUnmapped.slice(
        startIndex,
        startIndex + rowsPerPage
    )

    const pageCount = Math.ceil(campaignUnmapped.length / rowsPerPage)
    return (
        <>
            <div className="row">
                <div className="col-xs-12">
                    <div className="customDash-table" style={{ marginTop: '40px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: "center" }}>
                            <h5>Mapped Campaigns</h5>
                            <div className='HeadingFilter-Section'>

                                <div className='topsTabs' style={{ border: 'none' }}>
                                    <div className='rightTabs' style={{ padding: '0' }}>
                                        <button className={`rightSideBtn active`} style={{ background: '#035865', color: '#fff', cursor: "pointer", margin: '0 10px 0 0' }} onClick={() => download()}>Export</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='main-customized-table'>
                            <table className='table'>
                                <thead>
                                    <tr>

                                        <th>Campaign Name</th>
                                        <th>Aggregator Name</th>
                                        <th>Partner Name</th>


                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        paginatedData?.length > 0 ? paginatedData?.map((val, id) => {

                                            return (
                                                <tr key={id}>

                                                    <td>{val?.campaignName ?? ""}</td>
                                                    <td>{val?.aggregatorName ?? ""}</td>
                                                    <td>{val?.partnerName ?? ""}</td>

                                                </tr>
                                            )
                                        })
                                            : ""}



                                </tbody>
                            </table>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'end', margin: '20px 0' }}>
                            <Stack spacing={2}>
                                <Pagination
                                    count={pageCount}
                                    page={page}
                                    onChange={handleChange}
                                    color="primary"
                                />
                            </Stack>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
